import i18n from "../../../../constants/i18n";
import ET3Circle from "../../../../core/et3-circle";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { getKhattabatResultsStore } from "../../../../stores/khattabat-stores/results-store";

const HighlightOneOOneM = withLiteObserverAndTheme<{
  isHighlighted: boolean;
  conversationID: string;
  matchID: number;
}>((props) => {
  const { theme, isHighlighted, conversationID, matchID } = props;
  const { colors } = theme;

  return (
    <ET3Div
      width={180}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Circle
        size={13}
        style={{
          cursor: "pointer",
          border: `2px solid ${colors.all.dimGray}`,
          backgroundColor: isHighlighted
            ? colors.all.green
            : colors.all.transparent
        }}
        color={""}
        withShadow={false}
        onClick={async () => {
          await getKhattabatResultsStore().updateOneOOneMIsHighlightedDataBase({
            conversationID,
            matchID,
            currentHightlightState: isHighlighted
          });
        }}
      />
      <Et3Margin top={0} bottom={0} left={10} right={0} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        isSpan={false}
        text={i18n.get("HIGHLIGHT")}
        style={{}}
        color={""}
      />
    </ET3Div>
  );
});

export default HighlightOneOOneM;
